/* eslint-disable no-nested-ternary */
import formatValidOuterLink from "helpers/formatValidOuterLink";
import styles from "./customLinkTab.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import CustomLink from "@Components/CustomLink";

const CustomLinkTab = ({
  title,
  link,
  isCustomlink,
  to,
  linkClassName,
  titleClassName,
}: {
  title?: string;
  link: string;
  isCustomlink?: boolean;
  to?: string;
  linkClassName?: string;
  titleClassName?: string;
}) => {
  const validLink = formatValidOuterLink(link);

  return link ? (
    isCustomlink && to ? (
      <>
        <CustomLink to={to} className={linkClassName || styles.link}>
          {title}
        </CustomLink>
      </>
    ) : (
      <a
        href={validLink}
        target="_blank"
        rel="noopener noreferrer"
        className={linkClassName || styles.link}
      >
        {title}
      </a>
    )
  ) : (
    <div className={titleClassName || styles.title}>{title}</div>
  );
};

export default wrapperHOC(CustomLinkTab, {
  componentName: "CustomLinkTab",
});
